import React, { useEffect, useState } from "react";
import { statusColor } from "../lib/provinces";
import { titleCase } from "../lib/format";

export const LiveMonitor = ({ heatmap = [] }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!heatmap.length) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % heatmap.length), 4500);
    return () => clearInterval(t);
  }, [heatmap.length]);

  if (!heatmap.length) return null;
  const p = heatmap[idx];

  return (
    <div className="map-overlay live-monitor" data-testid="live-monitor">
      <div className="lm-eyebrow">
        <span className="lm-dot" /> LIVE MONITOR
      </div>
      <div className="lm-name">{titleCase(p.name)}</div>
      <div className="lm-row">
        <span className="lm-label">SCORE: {p.score}</span>
        <span
          className="lm-badge"
          style={{ borderColor: statusColor(p.status), color: statusColor(p.status) }}
        >
          {p.status?.toUpperCase()}
        </span>
      </div>
      <div className="lm-underline" />
    </div>
  );
};

export default LiveMonitor;
